"use strict";
(function () {
    let initializedNav = null;
    function closeMenu(nav, button) {
        nav.classList.remove("public-nav-open");
        button.setAttribute("aria-expanded", "false");
    }
    function toggleMenu(nav, button) {
        const open = !nav.classList.contains("public-nav-open");
        nav.classList.toggle("public-nav-open", open);
        button.setAttribute("aria-expanded", open ? "true" : "false");
    }
    function ensureMenu(nav, actions) {
        let button = nav.querySelector("[data-public-nav-toggle]");
        if (!button) {
            const menuId = actions.id || `public-nav-actions-${Math.random().toString(36).slice(2)}`;
            actions.id = menuId;
            button = document.createElement("button");
            button.type = "button";
            button.className = "public-nav-toggle";
            button.dataset.publicNavToggle = "1";
            button.setAttribute("aria-label", "Open navigation menu");
            button.setAttribute("aria-controls", menuId);
            button.setAttribute("aria-expanded", "false");
            button.innerHTML = "<span></span><span></span><span></span>";
            nav.insertBefore(button, actions);
            button.addEventListener("click", () => toggleMenu(nav, button));
            actions.addEventListener("click", (event) => {
                const target = event.target;
                if (target && target.closest("a, button"))
                    closeMenu(nav, button);
            });
            document.addEventListener("click", (event) => {
                const target = event.target;
                if (!target || nav.contains(target))
                    return;
                closeMenu(nav, button);
            });
            document.addEventListener("keydown", (event) => {
                if (event.key === "Escape")
                    closeMenu(nav, button);
            });
        }
        nav.classList.add("public-nav-has-menu");
        return button;
    }
    function displayName(account) {
        return String(account?.team_name || account?.display_name || account?.contact_name || account?.contact_email || "Player").trim();
    }
    function ensureTeamLink(actions) {
        let link = actions.querySelector('a[href^="/login"], a[href^="/player-portal"], a[href^="/team-portal"]');
        if (link)
            return link;
        const orgLink = actions.querySelector('a[href^="/org-portal"]');
        link = document.createElement("a");
        link.className = "nav-pill";
        link.href = "/login";
        link.textContent = "SIGN IN";
        actions.insertBefore(link, orgLink || null);
        return link;
    }
    function trimLabel(value) {
        const text = String(value || "Player").trim();
        return text.length > 20 ? `${text.slice(0, 18)}...` : text;
    }
    async function signOut(button) {
        button.disabled = true;
        button.textContent = "Signing Out";
        try {
            await fetch("/api/team-portal/logout", {
                method: "POST",
                credentials: "same-origin",
            });
        }
        finally {
            window.location.reload();
        }
    }
    async function init() {
        const nav = document.querySelector(".public-site-nav");
        if (!nav || initializedNav === nav)
            return;
        const actions = nav.querySelector(".top-actions");
        if (!actions)
            return;
        initializedNav = nav;
        ensureMenu(nav, actions);
        let result = null;
        try {
            const response = await fetch("/api/team-portal/session", {
                credentials: "same-origin",
                cache: "no-store",
            });
            if (!response.ok)
                return;
            result = await response.json();
        }
        catch {
            return;
        }
        if (!result || !result.loggedIn || !result.account)
            return;
        const teamLink = ensureTeamLink(actions);
        const name = displayName(result.account);
        teamLink.href = "/dashboard?view=player";
        teamLink.textContent = trimLabel(name);
        teamLink.title = `Open Player Portal for ${name}`;
        teamLink.classList.add("team-session-pill");
        if (actions.querySelector("[data-team-public-signout]"))
            return;
        const logout = document.createElement("button");
        logout.type = "button";
        logout.className = "nav-pill public-signout-pill";
        logout.dataset.teamPublicSignout = "1";
        logout.textContent = "SIGN OUT";
        logout.addEventListener("click", () => signOut(logout));
        const orgLink = actions.querySelector('a[href^="/org-portal"]');
        actions.insertBefore(logout, orgLink || null);
    }
    init();
    document.addEventListener("bracketr:public-nav-ready", init);
    document.addEventListener("DOMContentLoaded", init);
})();
//# sourceMappingURL=public-team-nav.js.map
